/** Parse Atera device_name into hostname + optional user/description in parentheses. */
export function parseDeviceLabel(deviceName) {
  if (!deviceName?.trim()) {
    return { hostname: null, subtitle: null }
  }
  const text = deviceName.trim()
  const paren = text.match(/^(.+?)\s+\((.+)\)$/)
  if (paren) {
    return { hostname: paren[1].trim(), subtitle: paren[2].trim() }
  }
  return { hostname: text, subtitle: null }
}

function latestAlertTime(alerts) {
  let max = 0
  for (const a of alerts) {
    const t = a.created ? new Date(a.created).getTime() : 0
    if (t > max) max = t
  }
  return max
}

/** Group open alerts by device; sort groups newest activity first. */
export function groupAlertsByDevice(alerts) {
  const map = new Map()

  for (const alert of alerts) {
    const key = alert.agent_id ?? alert.device_name ?? `alert-${alert.atera_id}`
    if (!map.has(key)) {
      const { hostname, subtitle } = parseDeviceLabel(alert.device_name)
      map.set(key, {
        key,
        agentId: alert.agent_id ?? null,
        hostname: hostname || alert.device_name || `Device ${alert.agent_id || 'unknown'}`,
        subtitle,
        customerName: alert.customer_name ?? null,
        alerts: [],
      })
    }
    const group = map.get(key)
    if (!group.customerName && alert.customer_name) {
      group.customerName = alert.customer_name
    }
    group.alerts.push(alert)
  }

  const groups = [...map.values()]
  for (const group of groups) {
    group.alerts.sort(
      (a, b) =>
        new Date(b.created || 0).getTime() - new Date(a.created || 0).getTime(),
    )
  }
  groups.sort((a, b) => latestAlertTime(b.alerts) - latestAlertTime(a.alerts))
  return groups
}
